import { TagKindSchema } from "@redotech/redo-model/tag";
import { z, null as zNull } from "zod";

export const deleteTag = {
  input: z.object({ name: z.string(), kind: TagKindSchema }),
  output: zNull(),
};
